import React from 'react';
import { useTranslation } from 'react-i18next';
import { getGroceryCategoryIcon } from '../../../utils/groceryCategoryIcon';

// Catégories en base (noms français) → clé stable pour la traduction.
const CATEGORY_KEYS = {
  'Entrée': 'starter',
  'Plat': 'main',
  'Dessert': 'dessert',
  'Desserts': 'dessert',
  'Boisson': 'drink',
  'Boissons': 'drink',
  'Snack': 'snack',
  'Snacks': 'snack',
  'Végétarien': 'vegetarian',
  'Petit-déjeuner': 'breakfast',
  'Soupe': 'soup',
  'Grillades': 'grill',
  'Infusions': 'infusion',
  'Condiments': 'condiment',
  'Épices': 'spice',
  'Africain': 'african',
  'Européen': 'european',
  'Asiatique': 'asian',
  'Fast-Food': 'fastFood',
};

const CategoriesSection = ({
  categories,
  categoriesLoading,
  selectedCategoryId,
  onCategoryClick,
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ width: '100%', marginBottom: '8px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '14px', textAlign: 'left' }}>
        <span style={{ fontFamily: 'Archivo, sans-serif', fontSize: '13px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#EF4C23' }}>
          {t('home.categories.eyebrow')}
        </span>
        <h2 style={{ margin: 0, fontFamily: 'Fraunces, Georgia, serif', fontWeight: 900, fontSize: 'clamp(22px, 3vw, 40px)', lineHeight: 1.05, letterSpacing: '-0.02em', color: '#051004' }}>
          {t('home.categories.title')}
        </h2>
      </div>

      {categoriesLoading ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(88px, 1fr))', gap: '14px' }}>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }} className="animate-pulse">
              <div style={{ width: '62px', height: '62px', borderRadius: '999px', background: '#FBF9D9' }}></div>
              <div style={{ height: '10px', width: '48px', borderRadius: '999px', background: '#FBF9D9' }}></div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(88px, 1fr))', gap: '14px' }}>
          {categories.map((cat) => {
            const isSelected = selectedCategoryId === cat.id;
            const key = CATEGORY_KEYS[cat.name?.trim()];
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => onCategoryClick(cat.id)}
                style={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 4px',
                  borderRadius: '24px',
                  fontFamily: 'Archivo, sans-serif',
                  fontSize: '13px',
                  textAlign: 'center',
                  color: isSelected ? '#054625' : 'rgba(5,16,4,0.78)',
                  fontWeight: isSelected ? 600 : 400,
                }}
              >
                <span
                  style={{
                    width: '62px',
                    height: '62px',
                    borderRadius: '999px',
                    display: 'grid',
                    placeItems: 'center',
                    background: isSelected ? '#054625' : '#FBF9D9',
                    overflow: 'hidden',
                  }}
                >
                  <img src={getGroceryCategoryIcon(cat.name)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </span>
                {key ? t(`home.categories.names.${key}`, cat.name) : cat.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CategoriesSection;
